export default [
    {
		path: '/solution',
		name: 'solution',
		component: () => import('@/views/solution/index'),
		meta: {
			metaInfo: {
			  title: "新语境教育模式 | 教育模式加盟 | 教育机构加盟 | 新语境幼儿园",
			  keywords: "新语境教育模式，教育模式加盟，教育机构加盟，新语境幼儿园，幼儿园连锁加盟，幼儿启蒙教育加盟，幼儿园品牌加盟，儿童教育机构，儿童学前教育，幼儿教育加盟，幼儿教育的加盟",
			  description: "新语境教育模式是为符合中国新时期教育改革深入发展需要，以国际视野，以语言为主，结合多种语言环境中优秀文化元素，通过实施多种语言的主题文化教育活动，培育中国学前儿童文化素养、奠基社会主义核心价值观、突出中国特色的创新型学前教育模式",
			},
		}
	},
]


// WEBPACK FOOTER //
// ./src/router/modules/solution.js